var  _ = require('underscore'),
    NoteUiModel = require('../../../../noteUI'),
    fvChannel = require('glRadio').channel('FV');

module.exports = NoteUiModel.extend({

    defaults: _.extend( {}, NoteUiModel.prototype.defaults, {
        // the selected stamp on the note view -- really the selected 'new' stamp
        // also passed into the view on render to tell if which should be selected (if new or if the decide to modify the existing)
        // TODO: name change here -- something like selectedUnsavedStamp

        // should now always be the getDefaultStampForNewNote, unless the user has no stamps
        selectedStamp: null

    }),
    initialize: function(options) {

        NoteUiModel.prototype.initialize.apply(this, arguments);

        var user = fvChannel.request('user'),
            selectedStamp;

        if ( user.hasGraphicStamps() ) {

            var stamps = user.getGraphicStamps();
            // in the UI, one is always assumed to be selected (can't be empty) ...  unless there are none)
            // this will be the first in the list
            selectedStamp = stamps.getDefaultStampForNewNote();
            this.set('selectedStamp', selectedStamp);

        }
    },
    getSelectedStampImgHeader: function() {
        return this.get('selectedStamp').get('imageHeader');
    }



});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/graphicStamp/uiModel.js
 ** module id = 302
 ** module chunks = 0
 **/